module.exports = __webpack_public_path__ + "f6b1a56fb8cb1244599b96db2aa95e91.png";